import { Link } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
import { getInvestorLocale } from '@app/utils/getInvestorLocale';
import FilterPopup from './filter/FilterPopup';
const Header = ({ onFilterChange, filters, showCreditScore, showInvestmentStatus }) => {
    const { t } = useTranslation();
    const locale = getInvestorLocale();
    return (<div className="flex justify-between items-center">
            <FilterPopup onFilterChange={onFilterChange} filters={filters} showCreditScore={showCreditScore} showInvestmentStatus={showInvestmentStatus}/>
            <Link href={`https://www.paysera.com/v2/${locale}/legal`} target="_blank" rel="noreferrer" label={t('financing.investing_page_table.legal_info')}/>
        </div>);
};
export default Header;
